module.exports = __webpack_public_path__ + "img/pic4.ece0f15b.png";